import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from './auth.service';

@Component({
  standalone: true,
  template: ``,
  selector: 'tt-auth-login',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  protected authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit() {
    if (this.authService.authenticated()) {
      this.router.navigate(['/']);
    } else {
      const queryParams = this.route.snapshot.queryParamMap;
      const returnUrl = queryParams.get('returnUrl') ?? undefined;

      let domainHint = queryParams.get('domain_hint') ?? undefined;
      let loginHint = queryParams.get('login_hint') ?? undefined;

      // If redirected through a guard, hints can be embedded in returnUrl.
      if ((domainHint == null || loginHint == null) && returnUrl) {
        const parsedHints = this.extractHintsFromReturnUrl(returnUrl);
        domainHint = domainHint ?? parsedHints.domainHint;
        loginHint = loginHint ?? parsedHints.loginHint;
      }

      this.authService.login(returnUrl, { domainHint, loginHint });
    }
  }

  private extractHintsFromReturnUrl(returnUrl: string): { domainHint?: string; loginHint?: string } {
    const queryStart = returnUrl.indexOf('?');
    if (queryStart < 0) {
      return {};
    }

    const search = returnUrl.slice(queryStart + 1);
    const params = new URLSearchParams(search);

    return {
      domainHint: params.get('domain_hint') ?? undefined,
      loginHint: params.get('login_hint') ?? undefined,
    };
  }
}
